import {UKCountryCode} from "./global";

export interface HouseTypology {
    code: string;
    imgUrl: string;
    xmlName: string;
    description: string;
    ageBand: {
        from: number;
        to: number;
    };
    houseType: string;
    storeys?: number;
    name?: string;
    bedrooms?: number;
    countryCode?: UKCountryCode;
    id: string;
    creationDateTime: string;
    updatedDateTime: string;
}

export interface HouseType {
    text: string | null;
    value: string;
    ageBands: AgeBand[];
}

export interface AgeBand {
    from: number;
    to: number;
}

export enum TypologyId {
    Typology,
    DwellingId,
    BerWowId
}

export enum FormType {
    TypicalHome = "TypicalHome",
    BER = "BER",
    MPRN = "MPRN",
    TypicalHomeUK = "TypicalHomeUK",
    Address = "Address",
    DwellingUpload = "DwellingUpload",
}

export enum FormIdType {
    TypicalHome = 0,
    BER = 3,
    MPRN = 1,
    // TypicalHomeUK = 0,
    AddressUK = 4,
}

export interface SelectionButtonsItem {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value: any;
    label?: string;
    content?: any;
    disabled?: boolean;
}

export interface SeaiPartialBer {
    address: SeaiPartialBerAddress;
    dateOfIssue: string;
    dEAPVersion: string;
    berNumber: string;
    mprn: string;
    berRating: string;
    energyValue: number;
    co2Emissions: number;
    dwellingTypeId: number;
    dwellingType: string;
    yearOfConstruction: string;
    floorArea: number;
}

export interface SeaiPartialBerAddress {
    addressLine1: string;
    addressLine2: string;
    addressLine3: string;
    county?: string;
    postCode?: string;
}

export interface MPRNDetails {
    address: {
        addressLine1: string;
        addressLine2: string;
        county: string;
        postCode: string;
    };
    dateOfIssue: string;
    deapVersion: string;
    berNumber: string;
    mprn: string;
    berRating: string;
    energyValue: number;
    co2Emissions: number;
    dwellingTypeId: number;
    dwellingType: string;
    yearOfConstruction: string;
    floorArea: number;
}